import { AUTOCOMPLETE_CONFIG } from '@/constants/autocomplete'

export const shouldShowCuratedAutocompleteSections = (
	query: string | undefined
): boolean =>
	(query ?? '').trim().length >=
	AUTOCOMPLETE_CONFIG.CURATED_SECTION_MIN_QUERY_LENGTH
